<template>
  <div class="history-paper" v-loading="paperloading">
    <el-breadcrumb separator=">">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>历年试卷</el-breadcrumb-item>
    </el-breadcrumb>
    <h1>历年试卷</h1>
    <div class="table-example">
      <div class="table-div clearfix">
        <table class="statistics-table-stage" cellspacing="0" cellpadding="0">
          <tr><td>学段</td></tr>
          <tr v-for="(item,index) of data" :key="index">
            <td :style="{  height: item.subjectAndExamNumberDtos.length * 40 + 'px' }">{{item.stageName}}</td>
          </tr>
          <tr><td class="">合计</td></tr>
        </table>
        <table class="statistics-table" cellspacing="0" cellpadding="0">
          <tr>
            <td class="head">学科</td>
            <td class="head">18年试卷数量</td>
            <td class="head">19年试卷数量</td>
            <td class="head">历年试卷数量</td>
          </tr>
          <template v-for="stage of data" >
            <tr v-for="(sub, subindex) of stage.subjectAndExamNumberDtos" :key="subindex">
              <td>{{sub.subjectName}}</td><td>{{sub.oneExamNumbers}}</td><td>{{sub.twoExamNumbers}}</td><td>{{sub.allExamNumbers}}</td>
            </tr>
        </template>
          <tr><td></td><td>{{total18}}</td><td>{{total19}}</td><td>{{totalall}}</td></tr>
        </table>
      </div>
      <div class="paper-example-div">
        <div class="paper-example-head">
          <div class="paper-example-head-left">实例试卷</div>
        </div>
        <div class="paper-example-body-div">
          <i class="iconfont iconword3"></i>
          <div class="paper-example-name" @click="seeShare(1)">2019届高三高考真题训练——人民版必修二  专题三  中国建设社会主义道路的探索</div>
        </div>
        <div class="paper-example-body-div">
          <i class="iconfont iconword3"></i>
          <div class="paper-example-name" @click="seeShare(2)">2019届高三历史人教版一轮复习考点集训：考点41   物质生活和习俗的变迁</div>
        </div>
        <div class="paper-example-body-div">
          <i class="iconfont iconword3"></i>
          <div class="paper-example-name" @click="seeShare(3)">2019届湘教版九年级数学下册单元测试(二)　圆(A卷)</div>
        </div>
      </div>
    </div>

  </div>
</template>
<script type="text/babel">
import commonService from '@/service/commonService'

export default {
  components: {
  },
  data: function () {
    return {
      data: [],
      total18: 0,
      total19: 0,
      totalall: 0,
      paperloading: false
    }
  },
  name: '',
  mounted () {
    this.getPaperNum()
  },
  methods: {
    seeShare (flag) {
      let routeUrl
      switch (flag) {
        case 1:
          routeUrl = this.$router.resolve({
            path: '/front/introduce/history-paper/paper-example-1'
          })
          break
        case 2:
          routeUrl = this.$router.resolve({
            path: '/front/introduce/history-paper/paper-example-2'
          })
          break
        case 3:
          routeUrl = this.$router.resolve({
            path: '/front/introduce/history-paper/paper-example-3'
          })
          break
      }
      window.open(routeUrl.href, '_blank')
    },
    async getPaperNum () {
      this.paperloading = true
      try {
        let resp = await commonService.getPaperNum()
        this.data = resp.data
        if (this.data && this.data.length > 0) {
          this.total18 = 0
          this.total19 = 0
          this.totalall = 0

          for (let item of this.data) {
            if (item && item.subjectAndExamNumberDtos.length > 0) {
              for (let temp of item.subjectAndExamNumberDtos) {
                this.total18 += temp.oneExamNumbers
                this.total19 += temp.twoExamNumbers
                this.totalall += temp.allExamNumbers
              }
            }
          }
        }
        this.paperloading = false
      } catch (e) {
        this.$message.error(e && e.msg)
        this.paperloading = false
      }
    }
  }
}

</script>
<style scoped>
</style>
<style>
  .history-paper{
    width: 1200px;
    margin: 0px auto;
    padding: 24px 0px;
  }
  .history-paper h1{
    margin: 40px 0px 30px 0px;
    font-size:24px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color: #000000;
    width: 840px;
    text-align: center;
  }

  .history-paper .table-example{
    overflow: hidden;
  }

  .history-paper .table-div{
    float: left;
    width: 840px;
  }

  .history-paper .paper-example-div{
    width:320px;
    background:#ffffff;
    box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    border-radius:6px;
    float: right;
    padding: 24px;
  }

  .history-paper .paper-example-div .paper-example-head{
    font-weight:400;
  }

  .history-paper .paper-example-div .paper-example-head .paper-example-head-left{
    font-size:16px;
    color: #333333;
    font-weight: 400;
  }

  .history-paper .paper-example-div .paper-example-body-div{
    margin: 20px 0px;
    width: 272px;
    overflow: hidden;
  }

  .history-paper .paper-example-div .paper-example-body-div i{
    margin-right: 10px;
    font-size: 16px;
    color: #688AE2;

  }

  .history-paper .paper-example-div .paper-example-body-div .paper-example-name{
    width: 246px;
    float: right;
    cursor: pointer;
    display:block;
    color: #666666;
  }

  .history-paper .paper-example-div .paper-example-body-div .paper-example-name:hover{
    color: #00aaff;
  }

  .history-paper .statistics-table-stage{
    border:1px solid #0096FF;
    background:linear-gradient(153deg,#1D3981,#00BF8F);
    width: 168px;
    text-align: center;
    font-size: 16px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-collapse:separate;
    color: #ffffff;
    font-weight: bold;
    float: left;
  }

  .history-paper .statistics-table-stage td{
    border-top: 0;
    border-bottom: 1px solid #ffffff;
    border-right: 0;
    border-left: 0;
  }

  .history-paper .statistics-table-stage .primary-school{
    height: 120px;
  }

  .history-paper .statistics-table-stage .middle-school{
    height: 440px;
  }

  .history-paper .statistics-table-stage .high-school{
    height: 360px;
  }

  .history-paper .statistics-table-stage tr:last-child td {
    border-bottom: 0;
  }

  .history-paper .statistics-table-stage tr td{
    width: 168px;
    height: 40px;
  }

  .history-paper .statistics-table .head{
    font-weight:bold;
    color: #002488;
  }

  .history-paper .statistics-table tr td{
    width: 168px;
    height: 40px;
    font-weight:400;
    color:#666666;
  }

  .history-paper .statistics-table .subject{
    font-weight:bold;
    color:#333333;
  }

  .history-paper .statistics-table{
    border-top:1px solid #0096FF;
    border-right:1px solid #0096FF;
    border-bottom:1px solid #0096FF;
    text-align: center;
    font-size: 16px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-collapse:separate;
  }

  .history-paper .statistics-table td {
    border-right: 1px solid #0096FF;
    border-bottom: 1px solid #0096FF;
    border-top: 0;
    border-left: 0;
  }

  .history-paper .statistics-table tr:last-child td {
    border-bottom: 0;
  }

  .history-paper .statistics-table .special {
    border-bottom: 0;
  }

  .history-paper .statistics-table tr td:last-child {
    border-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/introduce/history-paper/index.vue